









































































































































































































































import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { IWidget } from '@resclick/data-access';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { i18n } from '@/i18n';

import '@resclick/widgets';

@Component({
  components: {},
})
export default class TabThemeEditor extends Mixins(ModalTabMixin) {
  @Prop({ required: true }) propertyId!: string;
  form!: CrsForm<'properties', 'updateWidget'>;

  get sandbox() {
    return JSON.stringify(this.form.fields);
  }

  get themeOptions() {
    return [{ label: 'Vertical V1', value: 'VERTICAL_V1' }];
  }

  get areChildrenAllowedOptions() {
    return [
      { label: i18n.t('GENERAL.ALLOWED'), value: false },
      { label: i18n.t('GENERAL.NOT_ALLOWED'), value: true },
    ];
  }

  get initialEffectOptions() {
    return [
      { label: 'Toggle', value: 'TOGGLE' },
      { label: 'Flash', value: 'FLASH' },
      { label: 'Hidden', value: 'HIDDEN' },
    ];
  }

  get widgetTypeOptions() {
    return [
      { label: i18n.t('GENERAL.BOOKING_WIDGET'), value: 'PROPERTY_BOOKING_WIDGET' },
      { label: i18n.t('GENERAL.POPUP_WIDGET'), value: 'POPUP_WIDGET' },
      { label: i18n.t('GENERAL.CALL_ME_WIDGET'), value: 'CALL_ME_WIDGET' },
      { label: i18n.t('GENERAL.ONLINE_SUPPORT_WIDGET'), value: 'ONLINE_SUPPORT_WIDGET' },
    ];
  }

  getForm() {
    return compass.do('properties', 'findOneWidget', {
      params: { propertyId: this.propertyId, widgetId: this.id as string },
    });
  }

  created() {
    this.form = this.$crsForm('properties', 'updateWidget', {
      theme: 'VERTICAL_V1',
      effect: 'TOGGLE',
      childrenNotAllowed: false,
      style: {
        bgColor: '#ffffff',
        colorPrimary: '#294f8d',
        inputBgColor: '#ffffff',
        toggleTextColor: '#ffffff',
        btnBgColor: '#ffa500',
        btnTextColor: '#ffffff',
      },
    });

    this.$once('update-data', (data: Omit<IWidget, 'property'>) => {
      this.form = this.$crsForm('properties', 'updateWidget', data);

      if (!this.form.fields.style) {
        this.$set(this.form.fields, 'style', {
          bgColor: '#ffffff',
          colorPrimary: '#294f8d',
          inputBgColor: '#ffffff',
          toggleTextColor: '#ffffff',
          btnBgColor: '#ffa500',
          btnTextColor: '#ffffff',
        });
      }
    });
  }
}
